const HOME_KEY = "home";
const AWAY_KEY = "away";
const TEAM_KEYS = [HOME_KEY, AWAY_KEY];
const HOME_NAME = "Home Team";
const AWAY_NAME = "Away Team";
const XG_MAP = { dAtk: 0.01, sOn: 0.2, sOff: 0.05 };
const XG_KEYS = Object.keys(XG_MAP);

const LEVEL_STATS = ["dAtk", "sOn", "sOff", "shots"];

const FETCH_STATUS = {
  ACTIVE: "active",
  NON_ACTIVE: "non_active"
};

const MATCH_PART_KEYS = { HT: "HT", FT: "FT" };
const MATCH_PART_TITLES = { HT: "Half time", FT: "Full time" };

// TODO: not sure about naming
const HANDICAP_ORIGINAL_KEYS = { OU: "OVER_UNDER", handicap: "HANDICAP" };
const HANDICAP_KEYS = { OVER_UNDER: "OVER_UNDER", HANDICAP: "HANDICAP" };
const HANDICAP_TYPES = {
  [HANDICAP_KEYS.OVER_UNDER]: "OU",
  [HANDICAP_KEYS.HANDICAP]: "handicap"
};
const HANDICAP_TITLES = {
  [HANDICAP_KEYS.OVER_UNDER]: "O/U", // Over / Under
  [HANDICAP_KEYS.HANDICAP]: "AH" // Asian Handicap
};

const MATCH_CATEGORIES = {
  LIVE: "live",
  TICKER: "ticker",
  PREMATCH: "prematch"
};

const FAVORITE_STORAGE_KEYS = {
  [MATCH_CATEGORIES.LIVE]: `${MATCH_CATEGORIES.LIVE}-favorite`,
  [MATCH_CATEGORIES.TICKER]: `${MATCH_CATEGORIES.TICKER}-favorite`,
  [MATCH_CATEGORIES.PREMATCH]: `${MATCH_CATEGORIES.PREMATCH}-favorite`
};

const SORT_TYPES = {
  TIME: "time",
  STATS: "stats",
  TOTAL: "total",
  HANDICAP: "handicap",
  SIGNAL: "top last"
};

const SORT_ORDER = {
  ASC: "ASC",
  DESC: "DESC"
};

const STAT_LEVEL_CLASSES = {
  TEAM: "team-level",
  TIME: "has-background",
  TICKER_MATCH_PART: "has-text",
  TICKER_SIGNAL_PART: "has-background"
};

const ALL_COMPANY_ROW = { _id: 0, name: "All" };

class MatchList {
  constructor(state, matches, opts) {
    this.matches = [...matches];
    this.state = state;
    this.opts = opts || {};
  }

  static matchParts = Object.keys(MATCH_PART_KEYS);
  static handicapTypes = Object.values(HANDICAP_TYPES);

  static MATCH_FILTER_KEYS = {
    ALL: "ALL",
    FAVORITES: "FAVORITES",
    SEARCH: "SEARCH",
    CHANGES_ONLY: "CHANGES_ONLY",
    COMPANY: "COMPANY",
    SIGNALS: "SIGNALS",
    SIGNAL_TYPES: "SIGNAL_TYPES"
  };

  static MATCH_FILTER_NAMES = {
    [MatchList.MATCH_FILTER_KEYS.ALL]: "All",
    [MatchList.MATCH_FILTER_KEYS.FAVORITES]: "Favorites",
    [MatchList.MATCH_FILTER_KEYS.SEARCH]: "Search",
    [MatchList.MATCH_FILTER_KEYS.CHANGES_ONLY]: "Changes Only",
    [MatchList.MATCH_FILTER_KEYS.SIGNALS]: "Signals",
    [MatchList.MATCH_FILTER_KEYS.SIGNAL_TYPES]: "Signal types"
  };

  static filterMatches(matches, filter, filterValue) {
    const { MATCH_FILTER_KEYS, filterBySearch } = MatchList;
    if (filter === MATCH_FILTER_KEYS.ALL) {
      return matches;
    } else if (filter === MATCH_FILTER_KEYS.FAVORITES) {
      return matches.filter(match => match.isFavorite);
    } else if (filter === MATCH_FILTER_KEYS.SEARCH) {
      return filterBySearch(matches, filterValue);
    } else {
      return matches;
    }
  }

  static filterBySearch(matches, filterValue) {
    if (!filterValue) {
      return matches;
    }

    const searchText = filterValue.toLowerCase();
    return matches.filter(({ home, away, league }) => {
      const homeTeam = home.team ? home.team.name : "";
      const awayTeam = away.team ? away.team.name : "";
      const names = [homeTeam, awayTeam, league];
      return names.some((name = "") => name.toLowerCase().includes(searchText));
    });
  }

  getList(matchState) {
    const opts = this.opts;

    this.mapList()
      .filterList(matchState)
      .searchList(matchState)
      .sortList(matchState);

    const total = this.matches.length;

    if (opts.page && opts.perPage) {
      this.paginateList();
    }

    return {
      data: this.matches,
      total
    };
  }

  mapList() {
    const { matches, state } = this;
    console.log("NO used");

    this.matches = matches.map(match => ({
      ...match,
      isFavorite: (state.favorites || []).includes(match._id),
      mini: state.expanded.includes(match._id) === false,
      totalLevel:
        parseInt(match.home.statistic.level) +
        parseInt(match.away.statistic.level),
      $homeLevel: getLevelClass(
        match.home.statistic.level,
        STAT_LEVEL_CLASSES.TEAM
      ),
      $awayLevel: getLevelClass(
        match.away.statistic.level,
        STAT_LEVEL_CLASSES.TEAM
      ),
      $timeLevel: getLevelClass(match.timeLevel),
      ...TEAM_KEYS.reduce((acc, key) => {
        const value = match[key];
        return { ...acc, [key]: value };
      }, {})
    }));

    return this;
  }

  searchList({searchText}) {
    const { matches } = this;
    const { filterMatches, MATCH_FILTER_KEYS } = this.getClass();

    this.matches = filterMatches(matches, MATCH_FILTER_KEYS.SEARCH, searchText);
    return this;
  }

  getClass() {
    return MatchList;
  }

  filterList() {
    const { matches, state, opts } = this;
    const { filters } = state;
    const { filterMatches } = this.getClass();

    this.matches = filters.reduce((acc, filter) => {
      if (typeof filter === "string" && !opts.noTabFilter) {
        return filterMatches(acc, filter);
      } else if (typeof filter === "object") {
        return filterMatches(acc, filter.type, filter.value);
      } else {
        return acc;
      }
    }, matches);

    return this;
  }

  paginateList() {
    const opts = this.opts;

    if (opts && opts.page && opts.perPage) {
      const start = (opts.page - 1) * opts.perPage;
      this.matches = this.matches.slice(start, start + opts.perPage);
    }

    return this;
  }
}

function getLevelClass(level, type = STAT_LEVEL_CLASSES.TIME) {
  const color = getLevelColor(Number(level));
  return color ? `${type}-${color}` : "";
}

function getLevelColor(level) {
  switch (level) {
    case 1:
      return "success";
    case 2:
      return "warning";
    case 3:
      return "danger";
    default:
      return "";
  }
}

function getXGModel(team) {
  const result = XG_KEYS.reduce(
    (total, param) => total + (team.statistic[param] || 0) * XG_MAP[param],
    0
  );
  return result.toFixed(2);
}

function mapLiveSignals({home, away, liveSignals, time, scores}) {
  const score = home.statistic.score + away.statistic.score ;
  const firstTimeScore = scores && scores[1] ? scores[1].home + scores[1].away : null;

  return liveSignals.map(({over, gamePeriod})=>{
    if (
      (firstTimeScore !== null && over < firstTimeScore && gamePeriod == 1) ||
       (over < score && gamePeriod == 2)
      ) {
      return { over, gamePeriod, signalClass: 'has-background-success'};
    }
    if(over > firstTimeScore && gamePeriod == 1 && time > 45){
      return {over, gamePeriod, signalClass: 'has-background-danger'};
    }
    return { over, gamePeriod, signalClass: 'has-background-warning'};
  });
}

function mapList(matches, state) {

  return matches.map(match => {
    if(!match.scores) match.scores = {};
    if ((match.scores && !match.scores[1])) match.scores[1] = { home: 0, away: 0 };

    return {
    ...match,
    isFavorite: (state.favorites || []).includes(match._id),
    mini: state.expanded.includes(match._id) === false,
    liveSignals: mapLiveSignals(match),
    firstTime: match.time > 45 ? match.scores[1] : false,
    totalLevel:
      parseInt(match.home.statistic.level) +
      parseInt(match.away.statistic.level),
    $homeLevel: getLevelClass(
      match.home.statistic.level,
      STAT_LEVEL_CLASSES.TEAM
    ),
    $awayLevel: getLevelClass(
      match.away.statistic.level,
      STAT_LEVEL_CLASSES.TEAM
    ),
    $timeLevel: getLevelClass(match.timeLevel),
    ...TEAM_KEYS.reduce((acc, key) => {
      const value = match[key];
      return { ...acc, [key]: value };
    }, {})
  }});
}

export default {
  // Constants
  HOME_KEY,
  HOME_NAME,
  AWAY_KEY,
  AWAY_NAME,
  TEAM_KEYS,
  LEVEL_STATS,
  STAT_LEVEL_CLASSES,
  FAVORITE_STORAGE_KEYS,
  MATCH_CATEGORIES,
  FETCH_STATUS,
  SORT_ORDER,
  SORT_TYPES,
  MATCH_PART_KEYS,
  MATCH_PART_TITLES,
  HANDICAP_ORIGINAL_KEYS,
  HANDICAP_KEYS,
  HANDICAP_TYPES,
  HANDICAP_TITLES,
  ALL_COMPANY_ROW,
  // Classes
  MatchList,
  // Functions
  getXGModel,
  getLevelClass,
  getLevelColor,
  mapList
};
